import get from "lodash.get";

class AuthHelpers {
  setAccessToken(token) {
    localStorage.setItem("accessToken", token);
  }

  setPassToken(token) {
    localStorage.setItem("passToken", token);
  }

  // set token type (ministry m , ngo , temp t)
  setAccessTokenType(type) {
    localStorage.setItem("tt", type);
  }

  setUser(user) {
    if(user.hasOwnProperty('ngo') && user.ngo.hasOwnProperty('legalForm') ){
      localStorage.setItem('legalForm', user.ngo.legalForm.id)
      
    }
    localStorage.setItem("user", JSON.stringify(user));
  }

  isUserLoggedIn() {
    return localStorage.getItem("user") && localStorage.getItem("accessToken")
      ? true
      : false;
  }

  isUserTemp() {
    return localStorage.getItem("tt") === "t" ? true : false;
  }

  isUserMinistry() {
    return localStorage.getItem("tt") === "m" ? true : false;
  }

  isUserCentral() {
    return get(this.getUser(), "ministry_user_type");
  }

  isHasPublicBenefit() {
    return get(this.getUser(), "ngo").has_public_benefit;
  }

  setTransactionsNeedReview(num) {
    localStorage.setItem("transactions_need_review", JSON.stringify(num));
  }

  getTransactionsNeedReview() {
    return localStorage.getItem("transactions_need_review") || null;
  }

  getTransactionRoles() {
    return get(this.getUser(), "transactionRoles");
  }

  getAccessToken() {
    return localStorage.getItem("accessToken") || null;
  }

  getPassToken() {
    return localStorage.getItem("passToken") || null;
  }

  getAccessTokenType() {
    return localStorage.getItem("tt") || null;
  }

  checkAbility(slug) {
    var abilities = this.getUserAbilities();
    return abilities.some((el) => el.permission_slug == slug);
  }

  canNavigate(slug) {
    return this.canAction(slug, "S") && this.isUserLoggedIn();
  }

  // check if user have permission to do an action using action slug and action symbol(C , U , S , D , O)
  canAction(slug, action) {
    if (this.isUserTemp()) return true;
    var abilities = this.getUserAbilities();
    return abilities
      .find((el) => el.permission_slug == slug)
      ?.sub_permission.some((el) => el == action);
  }
  getUserAbilities() {
      if( localStorage.getItem('legalForm') == 1)
        return this.getUser().permissions.filter(item => item.permission_slug !== 'ngo_director_boards_administrative')
      else
      return this.getUser().permissions.filter(item => item.permission_slug !== 'ngo_director_boards_trustee')
    // return this.getUser().permissions;
  }
  getUser() {
    return JSON.parse(localStorage.getItem("user")) || null;
  }

  reset() {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("user");
    localStorage.removeItem("tt");
    localStorage.removeItem("passToken");
    localStorage.removeItem("ni");
  }
}

const authHelpers = new AuthHelpers();
export default authHelpers;
